import React from "react";
import { useLanguage } from "../i18n";

const LocalizedText = ({ vi, en }) => {
  const { language } = useLanguage();
  return <>{language === "vi" ? vi : en}</>;
};

export default LocalizedText;
